<div *ngIf="rupturasStat !== null" id="rupturasCont">
    <h2>Meta do mês</h2>
    <div id="rupturaNumber">
        <span>
            {{rupturasStat.meta_total | currency: 'pt-br' : 'R$'}}
            
        </span>
    </div>
    <div id="rupBalance">
        {{rupturasStat.total_sales | currency: 'pt-br' : 'R$'}} ({{rupturasStat.percentual_meta | number}}%)
    </div>
    <div id="rupNumberCont">
        <div class="rupNumber">
            <!--{{rupturasStat.meta_total | currency: 'pt-br' : 'R$'}}-->
        </div>
        <div class="rupNumber">
            <!--{{rupturasStat.comissao | number}}-->
        </div>
    </div>
</div>
